import { useOutletContext } from "react-router-dom";

import ArticlesTablesView from "../views/ArticlesTableView/ArticlesTablesView";

export default function ArticlesTable() {
	const { data, organization, channels } = useOutletContext();

	return <ArticlesTablesView organization={organization} data={data} channels={channels} />;
}
